import { render } from "./chartItem.vue?vue&type=template&id=7890edc2"
import script from "./chartItem.vue?vue&type=script&lang=js"
export * from "./chartItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__